import { Component, OnInit } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { OrderMenu } from '../../_models/orderMenu';
import { Subject } from 'rxjs';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { User } from '../../_models/user';
import { AccessSecurity } from '../../_models/accessSecurity';
import { Globals } from '../../_models/globals';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiIntegration } from '../../_services/api.integration';
import { AlertService } from '../../_services/alert.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-seller-orders-list',
  templateUrl: './seller-orders-list.component.html',
  styleUrls: ['./seller-orders-list.component.scss'],
})
export class SellerOrdersListComponent implements OnInit {

  ordersMainMenu: OrderMenu[] = [
    { displayName: "All", tabClicked: "all", orderStatus: "ALL", additional: "N" },
    { displayName: "New", tabClicked: "submitted", orderStatus: "CREATED", additional: "N" },
    { displayName: "In Process", tabClicked: "InProcess", orderStatus: "IN_PROCESS", additional: "N" },
    { displayName: "Ready to Ship", tabClicked: "readyToShip", orderStatus: "READY_TO_SHIP", additional: "N" },
    { displayName: "In Transit", tabClicked: "shipped", orderStatus: "SHIPPED", additional: "N" },
    { displayName: "Delivered", tabClicked: "Delivered", orderStatus: "DELIVERED", additional: "N" },
    { displayName: "RTO (Return to Origin)", tabClicked: "RTO", orderStatus: "RETURN", additional: "Y" },
    { displayName: "Hold", tabClicked: "hold", orderStatus: "ON_HOLD", additional: "Y" },
    { displayName: "Cancelled", tabClicked: "Cancelled", orderStatus: "CANCELLED", additional: "Y" }
  ];
  totalCount: number = 0;
  orderList: any;
  shipments: any;
  tabClicked: any;
  totalRecords: number;
  loading = true;
  orderStatus: any = 'ALL';
  previousStatus = '';
  orders: any;
  ohid: any;
  checkedList2 = [];
  cancelActivities: string = 'N';
  holdActivities: string = 'N';
  checkedOrderIdList = [];
  checkedListView = [];
  reason: string;
  masterSelected: boolean = false;
  dtOptions: DataTables.Settings = {};
  toDayDateAndTime = new Date().toLocaleString();
  dtElement: DataTableDirective;
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  errorMessage: string = "";
  userDrop2: any = 'ALL';
  cancelReasons: string;
  activityDetails: string;
  pdfGenerate: string = 'N';
  size: string;
  sizeError: string;

  constructor(private alertService: AlertService, private router: Router, private http: HttpClient, public g: Globals, private api: ApiIntegration, public user: User) {
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      let index = this.ordersMainMenu.findIndex((d) => d.tabClicked === this.g.pageTab);
      if (index > -1) {
        for (let ol of this.ordersMainMenu) {
          if (ol.tabClicked === this.g.pageTab) {
            this.populateTabData(this.g.pageTab, ol.orderStatus);
            this.switchPosition(ol);
          }
        }
      } else {
        this.tabClicked = "all";
        this.populateTabData('all', "ALL");
      }

    } else {
      this.tabClicked = "all";
      this.populateTabData('all', "ALL");
    }
  }

  tabChange() {
    //this.g.loaderDisplay="display";
  }

  getReasons() {
    this.api.getValues("1", 'OUTBOUND', 'CANCEL_REASON', 'Outbound Orders').subscribe((data: any) => {
      this.cancelReasons = data.tripleSetConfigDTOS;
    }, err => {
      console.log(err);
    });
  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false;
    }
    this.getCheckedShipList();
  }

  unHoldMultiOrders(orders) {
    for (let order of orders) {
      if (order.isSelected) {
        this.unHoldOrder(order);
      }
    }
    ;
  }

  /* getOrderCount() {
     this.loading = true;
     if (this.user.role == 'ACCOUNT_OWNER' || this.user.role === 'ROLE_USER' || this.user.role === 'AO_SELLER' || this.user.role === 'DEMO_ACCOUNT') {
       this.api.getShipmentsByAdmin("ALL", this.user.organizationId).subscribe((data: any) => {
       if(data) {
         this.totalRecords = data.noOfRecords;
         this.loading = false;
       }
     }, err=> {this.alertService.error('Error',err);
     });
     } else {
      this.api.getShipmentsByAdmin("ALL", "1").subscribe((data: any) => {
      if(data) {
        this.totalRecords= data.noOfRecords;
        this.loading = false;
      }
     }, err => {
    this.alertService.error('Error',err);
    });
    }
    }
 */
  populateTabData(triggered, orderStatus) {
    this.tabClicked = triggered;
    this.orderStatus = orderStatus;
    if (!this.previousStatus) {
      this.getOrdersByStatus(orderStatus);
    }
  }

  /* getOrdersByStatus(orderStatus) {
  alert(orderStatus);
       this.dtOptions = {
         "ordering": false,
         pagingType: 'full_numbers',
         lengthMenu: [20, 50, 100, 200],
         pageLength: 20,
         language: {
           searchPlaceholder: 'Search by Order # / Channel Order # / Phone Number / Email'
         },
         serverSide: true,
         ajax: (dataTablesParameters: any, callback) => {
           if (this.previousStatus !== this.orderStatus) {
             dataTablesParameters.start = 0;
             this.previousStatus = this.orderStatus;
           }
            dataTablesParameters.start = 0;
           let query: any = {
             accountOwnerId: this.user.accountOwnerId,
             orderStatus: this.orderStatus,
             sellerId: this.user.sellerId,
             organizationId: 1,
             page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
             size: dataTablesParameters.length
           }
           if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
             query.searchString = dataTablesParameters.search.value.trim();
           }
           //this.g.loaderDisplay = "display";
           var header1 = new HttpHeaders();
           header1 = header1.append('Content-Type', 'application/json');
           header1 = header1.append('Accept', 'application/json');
           header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
           this.http.get(environment.apiUrl + "api/getOrderByAOSeller", {params: query, headers: header1})
             .subscribe((resp: any) => {
               this.orders = resp.ordersData;
               this.g.loaderDisplay = "";
               this.totalRecords = resp.noOfOrders;
               this.orders.forEach((s) => {
                 s['isSelected'] = false;
               });
               callback({
                 recordsTotal: resp.noOfOrders,
                 recordsFiltered: resp.noOfOrders
               });
               },
               (err) => {
                 this.g.loaderDisplay = "";
                 this.alertService.error('Error', err);
               });
         }
       };
     }
  */
  getOrdersByStatus(orderStatus) {
    /* this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      language: {
        searchPlaceholder: 'Search by Order # / Channel Order # / Phone Number / Email'
      },
      serverSide: true,
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.orderStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.orderStatus;
        }
        let query: any = {
          orderStatus: this.orderStatus,
          orderType: 'ORDER',
          organizationId: 1,
          sellerId:this.user.sellerId,
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        if (this.user.role == 'ACCOUNT_OWNER' || this.user.role === "AO_SELLER") {
          query.accountOwnerId = this.user.accountOwnerId;
        }
     */
    this.g.loaderDisplay = "display";
    this.api.getOrderByAOSeller(this.user.accountOwnerId, this.orderStatus, this.user.organizationId, this.user.sellerId).subscribe((data: any) => {
      if (data) {
        if (this.orderStatus == 'ALL') {
          this.totalRecords = data.noOfRecords;
        }
        this.totalCount = data.noOfRecords;
        this.orders = data.orderDetails;
      }
      this.g.loaderDisplay = "";
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(true);
    });
  }

  switchPosition(om) {
    let index = this.ordersMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.ordersMainMenu[5].displayName) {
      this.ordersMainMenu[5].additional = 'Y';
    }
    var tmp = 4;
    for (let o of this.ordersMainMenu) {
      if (tmp < (this.ordersMainMenu || []).length) {
        if (om.displayName !== this.ordersMainMenu[tmp].displayName) {
          this.ordersMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }

  populate(orderChange) {
    this.api.getShipmentsByAdmin(orderChange, "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.orders = data.ordersData;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  getCheckedShipList() {
    this.checkedList2 = [];
    this.checkedOrderIdList = [];
    this.checkedListView = [];
    for (var i = 0; i < (this.orders || []).length; i++) {
      if (this.orders[i].isSelected) {
        this.checkedList2.push(this.orders[i]['orderHeaderId']);
        this.checkedOrderIdList.push(this.orders[i]['orderHeaderId']);
        this.checkedListView.push(this.orders[i]);
      }
    }
  }


  /* getApi(){
    this.g.loaderDisplay = "display";
      this.api.getOrderByAOSeller(this.user.accountOwnerId, "1",this.user.sellerId).subscribe((data: any) => {
      if(data) {
        this.totalCount = data.noOfRecords;
        this.orderList = data.orderDetails;
      }
      this.g.loaderDisplay = "";
    }, err=> {this.alertService.error('Error',err);
   });
  } */

  ngOnInit() {
  }

  syncOrders() {
    this.g.loaderDisplay = "display";
    this.api.toSyncNowStoreOrdersOrderId(this.user.sellerId, this.user.accountOwnerId, "1").subscribe((data: any) => {
      if (data['code'] == 200) {
        this.alertService.success('Orders', 'Sync Successfully');
        this.g.loaderDisplay = "";
        this.getOrdersByStatus(this.orderStatus);
      }
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });
  }

  disableAction(status) {
    let disable = true;
    let checkedList = [];

    if (this.orders && this.orders.length) {
      for (var i = 0; i < this.orders.length; i++) {
        if (this.orders[i].isSelected) {
          checkedList.push(this.orders[i]);
        }
      }
    }

    if (checkedList.length == 1) {

      if (this.tabClicked === 'submitted') {
        if (status === 'processing order' && checkedList[0].orderStatus === 'CREATED') {
          disable = false;
        }
        if (status === 'created' && checkedList[0].orderStatus !== 'CREATED') {
          disable = false;
        }

      }
      if (this.tabClicked === 'InProcess') {
        if (status === 'print invoice' && checkedList[0].orderStatus === 'IN_PROCESS') {
          disable = false;
        }
        if (status === 'print invoice' && checkedList[0].orderStatus === 'SKIP_INVOICE') {
          disable = false;
        }
        if (status === 'created' && (checkedList[0].orderStatus === 'SUBMITTED' || checkedList[0].orderStatus === 'LABEL_GENERATED')) {
          disable = false;
        }
      }

    } else {
      disable = true;
    }
    return disable;
  }

  processingOrder(orders) {
    this.router.navigate(['/admin/orderProcessing/' + this.checkedList2[0]]);
  }

  generateShippingLabel(orders) {
    let i = 0;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        this.ohid = order;
      }
    }
    ;
    if (i === 1) {
      if (this.ohid.thirdPartyShipLabelUrl !== null) {
        this.navigateShippingUrl(orders);
      } else {
        this.pdfGenerate = 'Y';
      }
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }

  close() {
    this.pdfGenerate = 'N';
    this.size = '';
  }

  navigateShippingUrl(orders) {
    let i = 0;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        this.ohid = order;
      }
    }
    ;
    if (i == 1) {
      let j = 0;
      for (j = 0; j < this.ohid.thirdPartyShipLabelUrl.length; j++) {
        window.open(this.ohid.thirdPartyShipLabelUrl[j], '_blank')
      }
    }
  }

  generateManifest(orderIds) {
    var headerInfo = new HttpHeaders();
    headerInfo = headerInfo.append('Content-Type', 'application/json');
    headerInfo = headerInfo.append('Accept', 'application/pdf');
    headerInfo = headerInfo.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/generateManifestPdfForOrders', {
      "accountOwnerId": this.user.accountOwnerId,
      "headerIds": orderIds,
      "organizationId": this.user.organizationId,
      "size": "A4"
    },
      { responseType: 'blob', headers: headerInfo }).subscribe((resp: any) => {
        this.g.loaderDisplay = "";
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'shipment_manifest_A4_' + this.toDayDateAndTime + '.pdf';
        saveAs(blob, filename);
        this.alertService.success('Success', 'Manifest generated successfully');
        this.populateTabData('InProcess', "IN_PROCESS");
      }, err => {
        this.g.loaderDisplay = "";
        console.log(err);
        this.alertService.error('Error', err);
      });
  }

  cancelOrderPopUp(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order.orderHeaderId;
      }
    }
    ;
    if (i === 1) {
      this.cancelActivities = 'Y';
      this.getReasons();
    }
  }

  closePopUp() {
    this.cancelActivities = 'N';
    this.activityDetails = "";
  }

  holdOrderPopUp(p) {
    if ((this.checkedList2 || []).length == 1) {
      this.holdMultiOrders(p)
    } else {
      this.holdActivities = 'Y';
    }
  }

  holdMultiOrders(orders) {
    for (let order of orders) {
      if (order.isSelected) {
        this.holdOrder(order);
      }
    }
    ;
  }

  holdOrder(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,//this.route.snapshot.params['id'],
      "orderStatus": "ON_HOLD",
      "organizationId": 1,
      "accountOwnerId": ord.accountOwnerId,
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Hold Successfully');
          this.closePopUpHold();
          //let index = this.orders.indexOf(ord);
          //this.orders.splice(index, 1);

          this.populateTabData('submitted', "SUBMITTED");
        }
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }

  closePopUpHold() {
    this.holdActivities = 'N';
    this.activityDetails = "";
  }

  splice(i, id) {
    let index = this.orders.findIndex((d) => d.orderHeaderId === id);
    if (index > -1) {
      this.orders[index].isSelected = false;
    }
    this.checkedList2.splice(index, 1);
    this.checkedOrderIdList.splice(index, 1);
    this.checkedListView.splice(index, 1);
  }

  printShipment() {
    console.log(this.ohid)

    this.sizeError = "";

    if (!this.size) {
      this.sizeError = 'Please select size';
    }

    if (this.sizeError != "") {
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/pdf');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "display";
    this.http.post(environment.apiUrl + 'api/generateShippingLabelPDF', {
      "headerId": this.ohid.orderHeaderId,
      "organizationId": this.user.organizationId,
      "accountOwnerId": this.ohid.accountOwnerId,
      "size": this.size
    },
      { responseType: 'blob', headers: header1 }).subscribe((resp: any) => {
        console.log(resp);
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'ib_' + this.ohid.orderHeaderId + '_shipping_label_' + this.size + '_' + this.toDayDateAndTime + '.pdf';
        saveAs(blob, filename);
        this.g.loaderDisplay = "";
        this.pdfGenerate = 'N';
        this.size = "";
        this.populateTabData('InProcess', "IN_PROCESS");
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }

  cancelMultiOrders(orders) {
    for (let order of orders) {
      if (order.isSelected) {
        this.cancelOrder(order);
      }
    }
    ;
  }

  cancelOrder(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,//this.route.snapshot.params['id'],
      "orderStatus": "CANCELLED",
      "organizationId": 1,
      "shippingOption": ord.shippingOption,
      "accountOwnerId": ord.accountOwnerId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Cancelled Successfully');
          this.closePopUp();
          this.populateTabData('submitted', "SUBMITTED");
        }
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }

  unHoldOrder(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,//this.route.snapshot.params['id'],
      "orderStatus": "UN_HOLD",
      "organizationId": 1,
      "accountOwnerId": ord.accountOwnerId,
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'UnHold Successfully');
          this.closePopUpHold();
          this.populateTabData('hold', "ON_HOLD");
        }
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }

}
